export default function ContactFooter() {
  return (
    <footer className="relative bg-foreground-950 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8 pt-24 md:pt-32 pb-8">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 mb-20">
          <div className="lg:w-[38%]">
            <div className="mb-12">
              <div className="w-20 h-20 rounded-full border border-background-200/20 flex items-center justify-center">
                <div className="w-8 h-8 border border-background-300/40 rotate-45" />
              </div>
            </div>
            <p className="text-base md:text-lg leading-[1.7] text-background-300/80 max-w-sm font-light">
              Professional engineering for the modern iOS platform. Built on principles of
              clean architecture, performance, and continuous improvement.
            </p>
            <div className="flex gap-4 mt-10">
              {[0, 1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="w-10 h-10 rounded-full border border-background-300/20 flex items-center justify-center"
                >
                  <div className="w-1.5 h-1.5 rounded-full bg-background-300/40" />
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[28%] flex flex-col gap-10">
            <div>
              <p className="text-[11px] tracking-[0.2em] uppercase text-background-400/60 font-medium mb-4">
                Address
              </p>
              <p className="text-sm leading-relaxed text-background-200/80 font-light">
                Meistri tn 6
                <br />
                Tallinn
                <br />
                13517
                <br />
                Estonia
              </p>
            </div>
            <div>
              <p className="text-[11px] tracking-[0.2em] uppercase text-background-400/60 font-medium mb-4">
                Phone
              </p>
              <p className="text-sm text-background-200/80 font-light">
                +372 57237756
              </p>
            </div>
            <div>
              <p className="text-[11px] tracking-[0.2em] uppercase text-background-400/60 font-medium mb-4">
                Email
              </p>
              <p className="text-sm text-background-200/80 font-light">
                contact@lineeasetech.com
              </p>
            </div>
          </div>

          <div className="lg:w-[34%] flex items-center justify-center">
            <div
              className="w-full h-[280px] rounded-2xl opacity-30"
              style={{
                backgroundImage:
                  'linear-gradient(160deg, oklch(0.25 0.008 75 / 0.4) 0%, oklch(0.18 0.005 72 / 0.2) 40%, oklch(0.22 0.006 74 / 0.35) 100%)',
              }}
            />
          </div>
        </div>

        <div className="border-t border-background-200/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400/50 font-light">
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
          <div className="flex gap-6">
            <span className="text-xs text-background-400/40 font-light cursor-default">
              Estonia
            </span>
            <span className="text-xs text-background-400/40 font-light cursor-default">
              Tallinn
            </span>
            <span className="text-xs text-background-400/40 font-light cursor-default">
              Engineering
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}